import { render, staticRenderFns } from "./PeopleListWidget.vue?vue&type=template&id=d9b0fa92"
import script from "./PeopleListWidget.vue?vue&type=script&lang=js"
export * from "./PeopleListWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports